import { IGoodThingsComeInThreeTemplate } from '@/types/components/ITemplate'
import { ArtistShowcaseCard } from '../../cards/ArtistShowcaseCard'
import { QuestionCard } from '../../cards/QuestionCard'

interface GoodThingsIn3Props {
  template: IGoodThingsComeInThreeTemplate
}

export const GoodThingsIn3 = ({
  template: {
    aboutArtist,
    artistShowcase,
    lastMeal,
    twoTruthsOneLie,
    workInThreeWords,
  },
}: GoodThingsIn3Props) => {
  return (
    <div className='flex w-full flex-col gap-6'>
      <div className='flex w-full max-w-[800px] flex-col gap-2 sm:mx-6 sm:mb-6 sm:gap-8 md:mx-12 lg:mx-auto'>
        <ArtistShowcaseCard
          title={artistShowcase.title}
          subtitle={artistShowcase.subtitle}
          content={artistShowcase.content}
          image={artistShowcase.image}
        />
        <QuestionCard title={lastMeal.title} content={lastMeal.content} />
        <QuestionCard
          title={twoTruthsOneLie.title}
          content={twoTruthsOneLie.content}
        />
        <QuestionCard
          title={workInThreeWords.title}
          content={workInThreeWords.content}
        />
        <QuestionCard title={aboutArtist.title} content={aboutArtist.content} />
      </div>
    </div>
  )
}
